import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import useSWR from 'swr';
import { CustomersDataGrid } from '../../components/datagrid/CustomersDataGrid';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { Unit } from '../../types/unit.types';
import { API_URL, fetcher } from '../../utils/apiUrl';
import { swrConfig } from '../Assets/AssetsEdit';

export function Customers() {
  const history = useHistory();
  const { setValue } = useBreadcrumbs();

  useEffect(() => {
    setValue({
      pageName: 'Customers',
      steps: [{ name: 'Home', pathToCutCount: 1 }],
    });
    return () => {
      setValue(null);
    };
  }, []);

  const { data, error } = useSWR<Unit[]>(
    `${API_URL.CUSTOMER_LIST}?visibleOnly=false`,
    fetcher,
    swrConfig,
  );

  const handleEditButton = (e): void => {
    history.push(`/customers/edit/${e.row.data.id}`);
  };

  return (
    <PageContentWrapper error={error} loading={!data}>
      <CustomersDataGrid data={data} handleEdit={handleEditButton} />
    </PageContentWrapper>
  );
}
export default Customers;
